import { render, staticRenderFns } from "./i-loader-indicator.vue?vue&type=template&id=515e69ad&scoped=true&"
import script from "./i-loader-indicator.vue?vue&type=script&lang=js&"
export * from "./i-loader-indicator.vue?vue&type=script&lang=js&"
import style0 from "./i-loader-indicator.vue?vue&type=style&index=0&id=515e69ad&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515e69ad",
  null
  
)

export default component.exports